/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.permissions.list.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.factory.notice',
  'acme.view.application.permissions.createModal.controllers',
  'acme.view.application.permissions.removeModal.controllers',
  'acme.common.factory.gridState'
])

.controller('PermissionsListController', ['$scope', '$uibModal', '$timeout', 'ApiService', 'NoticeFactory', 'GridStateFactory', function($scope, $uibModal, $timeout, ApiService, NoticeFactory, GridStateFactory) {

    $scope.permissionsList = {

      model: [],
      addModal: {},
      isLoaded: false,

      notice: new NoticeFactory(),

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'id',
            displayName: 'Id'
          },
          {
            field: 'name',
            displayName: 'Name'
          },
          {
            field: 'displayName',
            displayName: 'Display Name'
          }
        ]
      },
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Manage Permissions',
          buttonRight: {
            label: 'Create',
            permissions: 'PERMISSIONS_CREATE',
            action: function() {
              $scope.permissionsList.create();
            }
          }
        });

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getPermissions();

      },

      getPermissions: function() {
        ApiService.permissions.list(this.gridState.getGridState()).then(this.success.init, this.error.init);
      },

      create: function(response) {

        var self = $scope.permissionsList;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/permissions/modals/createPermission.tpl.html',
          size: 'lg',
          controller: 'PermissionsCreateModalController',
          resolve: {
            permissions: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (permission) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          ApiService.permissions.create(permission).then(function () {
            self.getPermissions();
          }, self.error.create);
        }, function () {
          // Do nothing
        });

      },

      success: {
        init: function(response) {
          var self = $scope.permissionsList;
          //next tick
          $timeout(function() {
            self.model = response.data.payload.list;
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
          }, 0);
          self.isLoaded = true;
        }
      },

      error: {
        init: function(response) {},
        create: function(response) {
          var self = $scope.permissionsList;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
        }
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.permissionsList;
        self.gridState.updateGridState(newPage, pageSize);
        self.getPermissions();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.permissionsList, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getPermissions();
        }
      }

    };

    $scope.permissionsList.init();

}]);